var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnedrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 25,
    viewBox: "0 0 38 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_81647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.554 7.16488L14.5544 7.16359L22.4189 11.8744L27.1053 9.90226L27.1055 9.90306C28.0578 9.49137 29.0844 9.27947 30.1219 9.28049C30.2947 9.28049 30.4656 9.28833 30.6356 9.29967C30.0721 7.1027 28.8827 5.11666 27.2119 3.58292C25.541 2.04917 23.4606 1.03374 21.2236 0.660034C18.9865 0.286323 16.689 0.570418 14.6104 1.47779C12.5317 2.38517 10.7613 3.87676 9.5144 5.77131C9.55447 5.77081 9.59392 5.76829 9.63408 5.76829C11.3722 5.76594 13.0764 6.24968 14.554 7.16488Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5545 7.16359L14.5541 7.16488C13.0764 6.24968 11.3723 5.76593 9.63416 5.76829C9.59401 5.76829 9.55449 5.77081 9.51448 5.77131C7.81329 5.79237 6.15 6.2766 4.70334 7.17196C3.25669 8.06733 2.08136 9.33998 1.30367 10.8531C0.525979 12.3663 0.175319 14.0628 0.289376 15.7603C0.403432 17.4578 0.977893 19.0921 1.95103 20.4876L8.88644 17.5691L11.9695 16.2717L18.8341 13.383L22.419 11.8744L14.5545 7.16359Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6356 9.29968C30.4656 9.28833 30.2947 9.28049 30.1219 9.28049C29.0844 9.27948 28.0578 9.49137 27.1055 9.90306L27.1053 9.90227L22.4189 11.8744L23.7779 12.6884L28.2324 15.3566L30.176 16.5207L36.8214 20.5013C37.4253 19.3803 37.7382 18.1258 37.7315 16.8526C37.7249 15.5793 37.3989 14.3281 36.7834 13.2135C36.1679 12.0989 35.2825 11.1566 34.2085 10.4728C33.1344 9.78903 31.9059 9.38568 30.6356 9.29969V9.29968Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1759 16.5207L28.2324 15.3566L23.7779 12.6884L22.4189 11.8744L18.834 13.383L11.9694 16.2717L8.88634 17.5691L1.95093 20.4876C2.81278 21.7268 3.96172 22.7389 5.29963 23.4376C6.63755 24.1363 8.12468 24.5008 9.63405 24.5H30.1219C31.4955 24.5004 32.8437 24.1289 34.0233 23.4249C35.2028 22.7208 36.1697 21.7106 36.8214 20.5013L30.1759 16.5207Z",
    fill: "#28A8EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_81647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.4634,
    height: 24,
    fill: "white",
    transform: "translate(0.268311 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedrive);
export default __webpack_public_path__ + "static/media/onedrive.544c6b8d4fc6f4cdd51f8b7a3c413207.svg";
export { ForwardRef as ReactComponent };